// @flow
import * as actions from './CardActions'
import type { CardStateT } from './CardState.type'
import type { CardT } from './Card.type'

type ActionT = {
  type: 'FETCH_CARDS_SUCCESS',
  payload: Array<CardT>
} | {
  type: 'FETCH_CARDS_ERROR',
  payload: Error
} | {
  type: 'FETCH_CARDS_LOADING'
}

const initialReducerState = {
  cards: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  currentCard: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  newCard: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  updateCard: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  },
  deleteCard: {
    isFetching: false,
    error: null,
    data: null,
    lastFetched: null
  }
}

export const cardsReducer = (state: CardStateT = initialReducerState, action: ActionT): CardStateT => {
  switch (action.type) {
    case actions.FETCH_CARDS_LOADING: {
      return {
        ...state,
        cards: {
          ...state.cards,
          isFetching: true,
          error: null
        }
      }
    }
    case actions.FETCH_CARDS_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        cards: {
          ...state.cards,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.FETCH_CARDS_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        cards: {
          ...state.cards,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.FETCH_CARD_LOADING: {
      return {
        ...state,
        currentCard: {
          ...state.currentCard,
          isFetching: true,
          error: null
        }
      }
    }
    case actions.FETCH_CARD_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentCard: {
          ...state.currentCard,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.FETCH_CARD_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        currentCard: {
          ...state.currentCard,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.CREATE_CARD_LOADING: {
      return {
        ...state,
        newCard: {
          ...state.newCard,
          isFetching: true,
          error: null,
          data: null
        }
      }
    }
    case actions.CREATE_CARD_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        cards: {
          ...state.cards,
          lastFetched,
          data: state.cards.data ? state.cards.data.concat([action.payload]) : [action.payload]
        },
        newCard: {
          ...state.newCard,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.CREATE_CARD_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        newCard: {
          ...state.newCard,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.UPDATE_CARD_LOADING: {
      return {
        ...state,
        updateCard: {
          ...state.updateCard,
          isFetching: true,
          error: null,
          data: null
        }
      }
    }
    case actions.UPDATE_CARD_SUCCESS: {
      const lastFetched = Date.now()
      return {
        ...state,
        updateCard: {
          ...state.updateCard,
          isFetching: false,
          lastFetched,
          data: action.payload,
          error: null
        }
      }
    }
    case actions.UPDATE_CARD_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        updateCard: {
          ...state.updateCard,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    case actions.DELETE_CARD_LOADING: {
      return {
        ...state,
        deleteCard: {
          ...state.deleteCard,
          isFetching: true,
          error: null,
          data: action.payload
        }
      }
    }
    case actions.DELETE_CARD_SUCCESS: {
      const lastFetched = Date.now()

      let newCards
      if (state.cards.data && state.deleteCard.data && state.deleteCard.data.id) {
        newCards = state.cards.data.filter((card) => {
          if (state.deleteCard.data && state.deleteCard.data.id) {
            return card.id !== state.deleteCard.data.id
          }
          return true
        })
      }

      return {
        ...state,
        cards: {
          ...state.cards,
          lastFetched,
          data: newCards || state.cards.data
        },
        deleteCard: {
          ...state.deleteCard,
          isFetching: false,
          lastFetched,
          data: null,
          error: null
        }
      }
    }
    case actions.DELETE_CARD_ERROR: {
      const lastFetched = Date.now()
      return {
        ...state,
        deleteCard: {
          ...state.deleteCard,
          isFetching: false,
          lastFetched,
          error: action.payload
        }
      }
    }
    default:
      return state
  }
}
